export default __webpack_public_path__ + "static/hero-logos-ec80a26f5a3910fb1d04788bd8aed028.png";